import {styled} from "@mui/material/styles"

export const StarRatingWrapper = styled("span")`
    min-height: 1rem;
    display: flex;
    line-height: 1;
    align-items: center;
`

export const StarContainer = styled("span")`
    font-size: 0.75rem;
    display: flex;

    svg {
        width: 13px;
        height: 12px;
        transform: ${props => (props.theme.direction === "rtl" ? "scaleX(-1);" : " scaleX(1);")}
            margin-top: 0.125rem;
        }
    vertical-align: top;
`
